import type { ProjectListResponsePage } from './projectListResponsePage';

/**
 * 프로젝트 목록 응답 데이터
 */
export interface ProjectListResponse {
  /** 응답 코드 (성공 또는 에러 식별) */
  code?: string;
  /** 응답 메시지 */
  message?: string;
  page?: ProjectListResponsePage;
  success?: boolean;
}
